import React, { Component } from 'react'
import Axios from 'axios'
import { SYSTEM_STATS } from '../../config/rest_endpoints'
import { getUser } from '../../actions/session'
import ProgressBar from 'react-bootstrap/ProgressBar'

class SystemStats extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            data: [],
            TodayInTotalCallDuration:'',
            TodayInTotalSuccessfulCalls:'',
            TodayInTotalDialedCalls:'',
            TodayInBilledCallDuration:'',
            TodayOutTotalCallDuration:'',
            TodayOutTotalSuccessfulCalls:'',
            TodayOutTotalDialedCalls:'',
            TodayOutBilledCallDuration:'',
        }
    }

    componentDidMount() {
        this.getSystemMonitor()
    }

    getSystemMonitor() {
        const { User } = this.state
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(SYSTEM_STATS, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                this.setState({
                    data: resp,
                    TodayInTotalCallDuration:resp.todayInTotalCallDuration,
                    TodayInTotalSuccessfulCalls:resp.todayInTotalSuccessfulCalls,
                    TodayInTotalDialedCalls:resp.todayInTotalDialedCalls,
                    TodayInBilledCallDuration:resp.todayInBilledCallDuration,
                    TodayOutTotalCallDuration:resp.todayOutTotalCallDuration,
                    TodayOutTotalSuccessfulCalls:resp.todayOutTotalSuccessfulCalls,
                    TodayOutTotalDialedCalls:resp.todayOutTotalDialedCalls,
                    TodayOutBilledCallDuration:resp.todayOutBilledCallDuration

                })
                console.log('res :>> ', resp);
            }
        }).catch(err => {
            console.log('err :>> ', err);
        })
    }

    render() {
        const { data,TodayInTotalCallDuration,TodayOutTotalCallDuration,TodayOutTotalSuccessfulCalls,TodayOutTotalDialedCalls,TodayInTotalDialedCalls,TodayInTotalSuccessfulCalls,TodayInBilledCallDuration,TodayOutBilledCallDuration } = this.state
      
        return (
            <div className="row">
                <div className="col-md-6">
                    <div style={{border:'1px solid #E2E8F0',borderRadius:'16px',background:'#FFFFFF',boxShadow:'0 1px 3px rgba(0,0,0,0.04)',overflow:'hidden'}}>
                        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 20px',borderBottom:'1px solid #F1F5F9'}}>
                            <h6 style={{fontWeight:'600',fontSize:'14px',color:'#0F172A',margin:0}}>Incoming System Stats</h6>
                            <div style={{display:'flex',alignItems:'center',gap:'6px'}}>
                                <span style={{width:'8px',height:'8px',borderRadius:'50%',background:'#10B981',display:'inline-block'}}></span>
                                <span style={{fontSize:'12px',color:'#475569'}}>Operational</span>
                            </div>
                        </div>
                        <div style={{padding:'20px'}}>
                            <ul className="list-unstyled mb-0">
                                <li className="mb-3">
                                    <div className="d-flex align-items-center mb-1"><span style={{fontSize:'13px',color:'#475569',fontWeight:'500'}}>Total Minutes Spent</span> <span style={{fontSize:'13px',color:'#94A3B8',marginLeft:'auto'}}>{TodayInTotalCallDuration == "0" ? 0 :TodayInTotalCallDuration.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayInTotalCallDuration} variant="danger" style={{ height: '0.375rem', borderRadius: '4px' }} />
                                </li>
                                <li className="mb-3">
                                    <div className="d-flex align-items-center mb-1"><span style={{fontSize:'13px',color:'#475569',fontWeight:'500'}}>Total Billed Duration</span> <span style={{fontSize:'13px',color:'#94A3B8',marginLeft:'auto'}}>{TodayInBilledCallDuration == "0" ? 0 : TodayInBilledCallDuration.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayInBilledCallDuration} variant="info" style={{ height: '0.375rem', borderRadius: '4px' }} />
                                </li>
                                <li className="mb-3">
                                    <div className="d-flex align-items-center mb-1"><span style={{fontSize:'13px',color:'#475569',fontWeight:'500'}}>Total Successful Calls</span> <span style={{fontSize:'13px',color:'#94A3B8',marginLeft:'auto'}}>{TodayInTotalSuccessfulCalls == "0" ? 0 : TodayInTotalSuccessfulCalls.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayInTotalSuccessfulCalls} variant="success" style={{ height: '0.375rem', borderRadius: '4px' }} />
                                </li>
                                <li>
                                    <div className="d-flex align-items-center mb-1"><span style={{fontSize:'13px',color:'#475569',fontWeight:'500'}}>Total Dialed Calls</span> <span style={{fontSize:'13px',color:'#94A3B8',marginLeft:'auto'}}>{TodayInTotalDialedCalls == "0" ? 0 : TodayInTotalDialedCalls.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayInTotalDialedCalls} variant="info" style={{ height: '0.375rem', borderRadius: '4px' }} />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div style={{border:'1px solid #E2E8F0',borderRadius:'16px',background:'#FFFFFF',boxShadow:'0 1px 3px rgba(0,0,0,0.04)',overflow:'hidden'}}>
                        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 20px',borderBottom:'1px solid #F1F5F9'}}>
                            <h6 style={{fontWeight:'600',fontSize:'14px',color:'#0F172A',margin:0}}>Outgoing System Stats</h6>
                            <div style={{display:'flex',alignItems:'center',gap:'6px'}}>
                                <span style={{width:'8px',height:'8px',borderRadius:'50%',background:'#10B981',display:'inline-block'}}></span>
                                <span style={{fontSize:'12px',color:'#475569'}}>Operational</span>
                            </div>
                        </div>
                        <div style={{padding:'20px'}}>
                            <ul className="list-unstyled mb-0">
                                <li className="mb-3">
                                    <div className="d-flex align-items-center mb-1"><span style={{fontSize:'13px',color:'#475569',fontWeight:'500'}}>Total Minutes Spent</span> <span style={{fontSize:'13px',color:'#94A3B8',marginLeft:'auto'}}>{TodayOutTotalCallDuration.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayOutTotalCallDuration} variant="danger" style={{ height: '0.375rem', borderRadius: '4px' }} />
                                </li>
                                <li className="mb-3">
                                    <div className="d-flex align-items-center mb-1"><span style={{fontSize:'13px',color:'#475569',fontWeight:'500'}}>Total Billed Duration</span> <span style={{fontSize:'13px',color:'#94A3B8',marginLeft:'auto'}}>{TodayOutBilledCallDuration.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayOutBilledCallDuration} variant="info" style={{ height: '0.375rem', borderRadius: '4px' }} />
                                </li>
                                <li className="mb-3">
                                    <div className="d-flex align-items-center mb-1"><span style={{fontSize:'13px',color:'#475569',fontWeight:'500'}}>Total Successful Calls</span> <span style={{fontSize:'13px',color:'#94A3B8',marginLeft:'auto'}}>{TodayOutTotalSuccessfulCalls.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayOutTotalSuccessfulCalls} variant="success" style={{ height: '0.375rem', borderRadius: '4px' }} />
                                </li>
                                <li>
                                    <div className="d-flex align-items-center mb-1"><span style={{fontSize:'13px',color:'#475569',fontWeight:'500'}}>Total Dialed Calls</span> <span style={{fontSize:'13px',color:'#94A3B8',marginLeft:'auto'}}>{TodayOutTotalDialedCalls.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span></div>
                                    <ProgressBar animated now={TodayOutTotalDialedCalls} variant="info" style={{ height: '0.375rem', borderRadius: '4px' }} />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default SystemStats